// extracted by mini-css-extract-plugin
export default {"disc":"_180fi"};